import filters from '@/api/filter';
export const config = {
  data() {
    return {
      salesSupportList: [], //个险销售支持
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          minWidth: 140
        },
        {
          title: '产品',
          key: 'productName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.productName}({params.row.productCode})
              </span>
            );
          }
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          minWidth: 100,
          align: 'center'
        },
      ];

      if (this.$units.isOkBao() || this.$units.isRYBB()) {
        columns.push({
          title: '个险销售支持',
          width: '140',
          align: 'center',
          key: 'saleSupportName',
          render(h, params) {
            return <span>{params.row.saleSupportName || '-'}</span>;
          }
        });
      }
      columns.push(
        {
          title: '投被保人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const res = params.row.insuranceName ? params.row.holderName + '/' + params.row.insuranceName : params.row.holderName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.insureTime, 'YYYY-MM-DD');
            return <span>{res}</span>;
          }
        },
        {
          title: '犹豫期',
          key: 'hesitateDate',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.hesitateDate, 'YYYY-MM-DD');
            return <span>{res}</span>;
          }
        },
        {
          title: '质检状态',
          slot: 'confirmRightStatusIn',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '风险原因',
          key: 'riskReason',
          width: 160,
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '出单团队',
          key: 'groupName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            const res = params.row.groupName ? params.row.orgName + '/' + params.row.groupName : params.row.orgName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center',
          fixed: 'right'
        }
      );
      this.columns = columns;
    }
  }
};
